import * as React from 'react';
import DialogBase from '../../Shared/DialogBase';
import { Box, Button, DialogActions, Stack, useMediaQuery } from '@mui/material';
import ImageViewer from './ImageViewer';
import PdfViewer from './PdfViewer';
import OfficeViewer from './OfficeViewer';
import downloadFromUri from '../../Shared/DownloadUri';
import { Download } from '@mui/icons-material';

export interface IViewFileDialogProps {
    open: boolean;
    onClose: () => void;
    name?: string;
    fileDownloadUri?: string;
}

export default function ViewFileDialog(props: IViewFileDialogProps) {
    const type = props.name?.split('.').pop();
    const biggerThan700 = useMediaQuery('(min-width:700px)');
    return (
        <DialogBase minWidth={biggerThan700 ? 900 : 500} title="Náhled" open={props.open} onClose={props.onClose}>
            <DialogActions>
                <Stack direction={'row'} spacing={2}>
                    <Button size='small' startIcon={<Download />} onClick={() => downloadFromUri(props.fileDownloadUri!)} variant='contained' color='primary'>Stáhnout</Button>
                    <Button size='small' onClick={props.onClose} variant='contained' color='primary'>Zavřít</Button>
                </Stack>
            </DialogActions>
            {type && props.fileDownloadUri && <Box>
                {type === 'pdf' && props.fileDownloadUri &&
                    <PdfViewer
                        // currentWidth={viewerWidth}
                        fileDownloadUri={props.fileDownloadUri}
                    />}
                {
                    (type === 'png' ||
                        type === 'jpg' ||
                        type === 'jpeg' ||
                        type === 'gif') &&
                    props.fileDownloadUri &&
                    <ImageViewer fileDownloadUri={props.fileDownloadUri} alt={'obrázek_' + type}></ImageViewer>
                }
                {
                    (type === 'xlsx' ||
                        type === 'xls' ||
                        type === 'docx' ||
                        type === 'doc') &&
                    props.fileDownloadUri &&
                    <OfficeViewer fileDownloadUri={props.fileDownloadUri} />
                }

            </Box>}
        </DialogBase>
    );
}
